import { action } from 'easy-peasy';
import { IActionSetIcd10Codes } from '../types';

const setIcd10Codes: IActionSetIcd10Codes = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.length;

  state.items = payload;
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setIcd10Codes;
